"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMeasure = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ObjRefConverter_1 = require("./ObjRefConverter");
var FilterConverter_1 = require("./FilterConverter");
var MeasureConverter_1 = require("./afm/MeasureConverter");
var convertPreviousPeriodDataSet = function (dataSet) {
    return {
        dataSet: ObjRefConverter_1.toBearRef(dataSet.dataSet),
        periodsAgo: dataSet.periodsAgo,
    };
};
var convertPreviousPeriodMeasureDefinition = function (measure) {
    return {
        previousPeriodMeasure: {
            measureIdentifier: sdk_model_1.measureMasterIdentifier(measure),
            dateDataSets: sdk_model_1.measurePreviousPeriodDateDataSets(measure).map(convertPreviousPeriodDataSet),
        },
    };
};
var convertPoPMeasureDefinition = function (measure) {
    return {
        popMeasureDefinition: {
            measureIdentifier: sdk_model_1.measureMasterIdentifier(measure),
            popAttribute: ObjRefConverter_1.toBearRef(sdk_model_1.measurePopAttribute(measure)),
        },
    };
};
var convertArithmeticMeasureDefinition = function (measure) {
    return {
        arithmeticMeasure: {
            measureIdentifiers: sdk_model_1.measureArithmeticOperands(measure),
            operator: sdk_model_1.measureArithmeticOperator(measure),
        },
    };
};
var convertSimpleMeasureDefinition = function (measure) {
    var identifier = sdk_model_1.measureIdentifier(measure);
    var uri = sdk_model_1.measureUri(measure);
    if (!identifier && !uri) {
        throw new Error("Measure has neither uri nor identifier.");
    }
    var aggregation = MeasureConverter_1.convertAggregation(sdk_model_1.measureAggregation(measure));
    var computeRatio = sdk_model_1.measureDoesComputeRatio(measure);
    var filters = (sdk_model_1.measureFilters(measure) || []).map(FilterConverter_1.convertFilter);
    return {
        measureDefinition: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ item: identifier ? { identifier: identifier } : { uri: uri } }, (aggregation && { aggregation: aggregation })), (computeRatio && { computeRatio: computeRatio })), (!isEmpty_1.default(filters) && { filters: filters })),
    };
};
var convertMeasureDefinition = function (measure) {
    if (sdk_model_1.isSimpleMeasure(measure)) {
        return convertSimpleMeasureDefinition(measure);
    }
    else if (sdk_model_1.isArithmeticMeasure(measure)) {
        return convertArithmeticMeasureDefinition(measure);
    }
    else if (sdk_model_1.isPoPMeasure(measure)) {
        return convertPoPMeasureDefinition(measure);
    }
    else if (sdk_model_1.isPreviousPeriodMeasure(measure)) {
        return convertPreviousPeriodMeasureDefinition(measure);
    }
    throw new Error("Unknown measure type");
};
exports.convertMeasure = function (measure) {
    var alias = sdk_model_1.measureAlias(measure);
    var format = sdk_model_1.measureFormat(measure);
    var title = sdk_model_1.measureTitle(measure);
    return {
        measure: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ definition: convertMeasureDefinition(measure), localIdentifier: sdk_model_1.measureLocalId(measure) }, (alias && { alias: alias })), (format && { format: format })), (title && { title: title })),
    };
};
//# sourceMappingURL=MeasureConverter.js.map